/* eslint-disable indent */
import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ICFeedItem } from '../models/ic/ic-feed-item';
import { ICTipoFeedItem, IntervaloAbsoluto, ModeloDeEstatistica, PerfilDoUsuario, TipoDeEstatistica } from '../models/enum';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { ICService } from '../services/ic.service';
import { ICUsuario } from '../models/ic/ic-usuario';
import { EstatisticaService } from '../services/estatistica.service';
import { EstatisticaSintetica } from '../models/estatistica-sintetica';
import { IntervaloDeTempo } from '../models/intervalo-de-tempo';
import { UsuarioLogado } from '../models/usuario-logado';
import { GlobalService } from '../services/global.service';
import { IntervaloDeTempoService } from '../services/intervalo-de-tempo.service';
import { Configuracao } from '../models/configuracao';
import { UtilitarioService } from '../services/utilitario.service';
import { PremissasService } from '../services/premissas.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { IntegradorModalComponent } from '../modals/integrador-modal/integrador-modal.component';

declare const $: any;

@Component({
  selector: 'app-icdash-board',
  templateUrl: './icdash-board.component.html',
  styleUrls: ['./icdash-board.component.scss']
})
export class ICDashBoardComponent implements OnInit, OnDestroy {

  private novoICFeedItemSubscription$: Subscription;
  public config: PerfectScrollbarConfigInterface = {};

  integradores: ICUsuario[] = [];

  buscandoIntegradores = false;

  feedIntegradores: ICFeedItem[] = [];

  usuarioLogado: UsuarioLogado;

  intervaloDeTempo: IntervaloDeTempo = new IntervaloDeTempo();

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };
  cardColor: string = '#eee';

  // options
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;

  // estatisticas =
  //   [
  //     { modelo: ModeloDeEstatistica.IntegradoresAtivos, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'done', texto: 'ativos', cor: 'text-primary' },
  //     { modelo: ModeloDeEstatistica.AcessosIntegradores, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'login', texto: 'logaram', cor: 'text-info' },
  //     { modelo: ModeloDeEstatistica.Orcamentos, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'assignment', texto: 'orçamentos', cor: 'text-info' },
  //     {
  //       modelo: ModeloDeEstatistica.Pedidos, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'assignment_turned_in', texto: 'pedidos', cor: 'text-info',
  //       subs: [
  //         { modelo: ModeloDeEstatistica.PedidosNaoConfirmados, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'done', texto: 'confirmados', cor: 'text-success' },
  //         { modelo: ModeloDeEstatistica.PedidosConfirmados, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'hourglass_empty', texto: 'não confirmados', cor: 'text-warning' }
  //       ]
  //     },
  //     { modelo: ModeloDeEstatistica.Simulacoes, tipo: TipoDeEstatistica.Quantidade, estatistica: new EstatisticaSintetica(), icone: 'content_paste_search', texto: 'simulações', cor: 'text-secondary' },
  //   ];

  estatisticasIndicadores: EstatisticaSintetica[] = [];
  estatisticasPedido: EstatisticaSintetica[] = [];

  idVisual: any;

  premissasSistema: PremissasSistema;

  constructor(private notificacaoService: NotificacaoService, private carregandoService: CarregandoService, private iCService: ICService,
    private estatisticaService: EstatisticaService, private globalService: GlobalService, private intervaloDeTempoService: IntervaloDeTempoService,
    private utilitarioService: UtilitarioService, private host: ElementRef<HTMLElement>, private premissasService: PremissasService,
    private router: Router, public dialog: MatDialog) {
    this.idVisual = JSON.parse(localStorage.getItem('idVisual'));
  }

  async ngOnInit() {

    await this.buscarPremissasSistema();

    if (!this.premissasSistema.feedDeIntegradores){
      this.router.navigate(['/']);
    }

    // Exemplo de uso
    this.colorScheme.domain = this.utilitarioService.generateShades(this.idVisual.cores.corPrimary, 8);

    this.host.nativeElement.style.setProperty('--cor-destaque', this.utilitarioService.lightenColor(this.idVisual.cores.corPrimary, 80));

    await this.buscarIntegradores();
    await this.buscarIntervaloDeTempo();

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.buscarEstatisticas();

    this.novoICFeedItemSubscription$ = this.notificacaoService.novoICFeedItem.subscribe(async (data: ICFeedItem) => {

      if (data === null || data === undefined || data.exibirNoFeed) {
        this.buscarFeed();
      }

      if (data !== null && data !== undefined) {
        switch (data.tipo) {

          case ICTipoFeedItem.Login:
          case ICTipoFeedItem.Logout:
          case ICTipoFeedItem.NovoIntegrador:
          case ICTipoFeedItem.PerdeuIntegrador:
            this.buscarEstatisticas();
            await this.buscarIntegradores();
            break;

          case ICTipoFeedItem.NovoOrcamento:
          case ICTipoFeedItem.NovoPedido:
          case ICTipoFeedItem.NovaSimulacao:
          case ICTipoFeedItem.ConfirmouPedido:
          case ICTipoFeedItem.EditouOrcamento:
          case ICTipoFeedItem.EditouPedido:
            this.buscarEstatisticas();
            break;

          default:
            break;
        }
      }

    });
  }

  async buscarIntegradores() {
    try {
      this.integradores = await this.iCService.buscarIntegradores().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.buscandoIntegradores = false;
    }
  }

  async buscarIntervaloDeTempo() {
    try {
      this.carregandoService.mostra('buscarIntervaloDeTempo');
      this.intervaloDeTempo = await this.intervaloDeTempoService.consultarIntervaloDeTempoAbsoluto(IntervaloAbsoluto.Hoje).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarIntervaloDeTempo');
    }
  }

  ngOnDestroy(): void {
    if (this.novoICFeedItemSubscription$ !== null && this.novoICFeedItemSubscription$ !== undefined) {
      this.novoICFeedItemSubscription$.unsubscribe();
    }
  }

  buscarQtdIntegradores(logados: boolean) {
    return this.integradores.filter(p => p.logado === logados).length;
  }

  buscarFeed() {
    this.feedIntegradores = this.iCService.buscarFeed();

    this.feedIntegradores.forEach(p => {
      if (p.pendente) {
        setTimeout(() => {
          p.pendente = false;
          this.iCService.salvarFeed(this.feedIntegradores);
        }, 2000);
      }
    });


  }

  buscarEstatisticas() {
    this.buscarEstatisticasIndicadores();
    this.buscarEstatisticasPedido();
  }

  buscarEstatisticasIndicadores() {
    this.estatisticaService.consultarListaEstatisticaSintetica([ModeloDeEstatistica.IntegradoresAtivos,
    ModeloDeEstatistica.AcessosIntegradores, ModeloDeEstatistica.Simulacoes, ModeloDeEstatistica.Orcamentos
    ], TipoDeEstatistica.Quantidade,
      this.intervaloDeTempo.dataHoraInicio, this.intervaloDeTempo.dataHoraTermino, null, this.usuarioLogado.id, null).subscribe(
        (dados) => {
          this.estatisticasIndicadores = dados;
          if (this.estatisticasIndicadores !== null && this.estatisticasIndicadores !== undefined && this.estatisticasIndicadores.length > 0) {
            this.estatisticasIndicadores[0].name = 'Ativos';
            this.estatisticasIndicadores[1].name = 'Logaram';
          }
        },
        (erro) => {
        }
      );
  }

  buscarEstatisticasPedido() {
    this.estatisticaService.consultarListaEstatisticaSintetica([ModeloDeEstatistica.PedidosConfirmados, ModeloDeEstatistica.PedidosNaoConfirmados],
      TipoDeEstatistica.Quantidade, this.intervaloDeTempo.dataHoraInicio, this.intervaloDeTempo.dataHoraTermino, null, this.usuarioLogado.id, null).subscribe(
        (dados) => {
          this.estatisticasPedido = dados;

          if (this.estatisticasPedido !== null && this.estatisticasPedido !== undefined && this.estatisticasPedido.length > 0) {
            this.estatisticasPedido[1].name = 'Não confirmados';
          }

        },
        (erro) => {
        }
      );
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  abrirModalIntegrador(idIntegrador) {
    const dialogRef = this.dialog.open(IntegradorModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { idIntegrador: idIntegrador },
      panelClass: 'modal-card'
    });
  }

  // buscarEstatisticas(estatisticas) {
  //   estatisticas.forEach(p => {
  //     this.buscarEstatistica(p);
  //     if (p.subs !== null && p.subs !== undefined && p.subs.length > 0) {
  //       this.buscarEstatisticas(p.subs);
  //     }
  //   });
  // }

  // buscarEstatistica(estatistica) {
  //   this.estatisticaService.consultarEstatisticaSintetica(estatistica.modelo, estatistica.tipo,
  //     this.intervaloDeTempo.dataHoraInicio, this.intervaloDeTempo.dataHoraTermino, null, this.usuarioLogado.id, null).subscribe(
  //       (f) => {
  //         estatistica.estatistica = f;
  //       },
  //       (erro) => {
  //       }
  //     );
  // }
}
